






















/* eslint-disable no-return-await */
import '@/polyfills/custom-events';
import {
  useAsync, ref, defineComponent, onMounted, Ref, computed,
} from '@nuxtjs/composition-api';
import { Header, Footer } from '@rpl/menu';
import { throttle } from 'lodash-es';
import { PortalTarget } from 'portal-vue';
import { createNamespacedHelpers } from 'vuex-composition-helpers';

import apiUrls from '@/apiUrls.config.js';
import BlogMenu from '@/components/blog/BlogMenu.vue';
import { IMainMenuElement, IBlogMenuElement } from '@/types/IMenu';

import { UseRainbowContext } from '../context/RainbowContext';

const { useGetters } = createNamespacedHelpers('schowek');
export default defineComponent({
  name: 'DefaultLayout',
  components: {
    Header,
    Footer,
    BlogMenu,
    PortalTarget,
  },
  provide: {
    SitemapCmpSettings: true,
  },
  middleware: ['blog/routeAuth'],
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setup() {
    const { $http, store, $cookies } = UseRainbowContext();
    // Tworzenie fake'owego contextu dla footer'a
    // W innym wypadku computed które wykonują commity wpadają w pętle
    const rCtx = { $cookies };
    const desktopMenu: Ref<null | Array<IMainMenuElement>> = useAsync(async () => await $http.$get(apiUrls.menu));
    const blogMenu: Ref<null | Array<IBlogMenuElement>> = useAsync(async () => await $http.$get(apiUrls.blogMenu));
    const mobileMenu: Ref<null | Array<IMainMenuElement>> = ref([]);
    const isDesktopMenu = ref(true);
    const footer = useAsync(async () => await $http.$get(apiUrls.footer));
    const icons = ref({});
    const noScroll = ref(false);

    let scrollThrottled;
    let resizeThrottled;
    const { getSchowekIlosc } = useGetters(['getSchowekIlosc']);

    useAsync(async () => await store.dispatch('schowek/setSchowekIlosc'));
    if (process.client) {
      scrollThrottled = new CustomEvent('scrollThrottled', {
        detail: {
          getScrollPosition: () => window.pageYOffset,
        },
      });

      resizeThrottled = new CustomEvent('resizeThrottled');
    }

    const toggleNoScroll = () => {
      if (process.server) {
        return;
      }

      const $body = document.getElementsByTagName('body')[0];

      if (noScroll && $body) {
        $body.scrollTo && $body.scrollTo(0, 0);
        $body.classList.add('no-scroll');
      } else {
        $body.classList.remove('no-scroll');
      }
    };

    const setIsDesktopMenu = () => {
      if (window.innerWidth > 993) isDesktopMenu.value = true;
      else isDesktopMenu.value = false;
    };

    const resize = () => {
      document.dispatchEvent(resizeThrottled);
      setIsDesktopMenu();
    };

    const initMobileMenu = () => {
      if (desktopMenu && desktopMenu.value) {
        desktopMenu.value.map((element) => {
          if (element.Nazwa === 'Blog' && blogMenu && blogMenu.value) {
            element.DefaultOpen = true;
          } else {
            element.DefaultOpen = false;
          }

          return element;
        });
        const desktopMenuCopy = JSON.parse(JSON.stringify(desktopMenu.value));

        if (desktopMenuCopy.length > 0) {
          desktopMenuCopy.sort((a, b) => a.Kolejnosc - b.Kolejnosc);

          const blog = desktopMenuCopy.find((element) => element.Nazwa === 'Blog');
          const firstElementKolejnosc = desktopMenuCopy[0].Kolejnosc;

          for (let i = 0; i < desktopMenuCopy.length - 1; i++) {
            desktopMenuCopy[i].Kolejnosc = desktopMenuCopy[i + 1].Kolejnosc;
          }
          blog.Kolejnosc = firstElementKolejnosc;

          desktopMenuCopy.map((element) => {
            if (element.Nazwa === 'Blog' && blogMenu && blogMenu.value) {
              element.URL = '#';
              element.ElementyWRzedzie = 3;
              element.ListaElementow = blogMenu.value.map((menuB, index) => ({
                ElementID: index,
                MenuID: element.MenuID,
                Nazwa: menuB.Nazwa,
                Opis: menuB.Nazwa,
                IconURL: '',
                IconPath: '',
                URL: `/blog${menuB.KategoriaUrl}`,
                NoweOkno: false,
                Kolejnosc: index,
                CzyIndywidualnyIconKolor: false,
                Kolor: '#FFD92D',
              }));
            }

            return element;
          });
        }

        mobileMenu.value = desktopMenuCopy;
      }
    };
    const scroll = () => {
      document.dispatchEvent(scrollThrottled);
    };

    onMounted(() => {
      if (process.client) {
        window.addEventListener('resize', throttle(resize, 30));
        document.addEventListener('scroll', throttle(scroll, 30));
        initMobileMenu();
        setIsDesktopMenu();
      }
    });

    const menu = computed(() => (isDesktopMenu.value ? desktopMenu.value : mobileMenu.value));

    const onSitemapClick = (id: string) => {
      if (id !== 'cmp-settings') return;
      (window as any).cmp?._instance.exposed.openSettings();
    };

    return {
      noScroll,
      toggleNoScroll,
      scrollThrottled,
      resizeThrottled,
      icons,
      getSchowekIlosc,
      desktopMenu,
      mobileMenu,
      footer,
      blogMenu,
      menu,
      isDesktopMenu,
      rCtx,
      onSitemapClick,
    };
  },
});
